/*
  Évora — Scroll Chapters engine
  Runs once per .evora-chapters section on the page. Computes, per chapter,
  how "covered" it currently is by the next chapter sliding over it
  (0 = fully revealed/active, 1 = fully covered), and toggles classes +
  a small parallax offset from that. rAF-throttled scroll listener —
  no external animation library required.

  Also owns the desktop/mobile media swap: each chapter can render both
  a --desktop and a --mobile media wrap (CSS shows only one via a
  749px breakpoint). Videos use preload="none" and are never autoplayed
  via the HTML attribute — this script explicitly plays only the
  currently-visible one and pauses the hidden one, so a mobile visitor
  never downloads or decodes a desktop-only video (and vice versa).
*/
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function activeVideoFor(chapter, isMobile) {
    var wrap = chapter.querySelector(
      isMobile ? '.evora-chapter-media-wrap--mobile' : '.evora-chapter-media-wrap--desktop'
    );
    return wrap ? wrap.querySelector('video') : null;
  }

  function hiddenVideoFor(chapter, isMobile) {
    var wrap = chapter.querySelector(
      isMobile ? '.evora-chapter-media-wrap--desktop' : '.evora-chapter-media-wrap--mobile'
    );
    return wrap ? wrap.querySelector('video') : null;
  }

  function syncVideoForBreakpoint(chapter, mql) {
    var isMobile = mql.matches;
    var active = activeVideoFor(chapter, isMobile);
    var hidden = hiddenVideoFor(chapter, isMobile);

    if (hidden && !hidden.paused) {
      hidden.pause();
    }
    if (active && active.paused) {
      var playPromise = active.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {});
      }
    }
  }

  function initEvoraChapters(root) {
    var chapters = Array.prototype.slice.call(root.querySelectorAll('.evora-chapter'));
    if (!chapters.length) return;

    var mql = window.matchMedia(MOBILE_QUERY);
    chapters.forEach(function (chapter) {
      syncVideoForBreakpoint(chapter, mql);
    });
    var onBreakpointChange = function () {
      chapters.forEach(function (chapter) {
        syncVideoForBreakpoint(chapter, mql);
      });
    };
    if (mql.addEventListener) {
      mql.addEventListener('change', onBreakpointChange);
    } else if (mql.addListener) {
      mql.addListener(onBreakpointChange);
    }

    var ticking = false;

    function update() {
      var vh = window.innerHeight;

      chapters.forEach(function (chapter, i) {
        var rect = chapter.getBoundingClientRect();
        var next = chapters[i + 1];
        var coverProgress = 0;

        if (next) {
          var nextRect = next.getBoundingClientRect();
          var raw = 1 - Math.min(Math.max(nextRect.top / vh, 0), 1);
          coverProgress = raw;
        }

        chapter.classList.toggle('is-active', rect.top <= 4 && coverProgress < 0.5);
        chapter.classList.toggle('is-covered', coverProgress >= 0.5);

        var content = chapter.querySelector('.evora-chapter-content');
        if (content) {
          if (coverProgress > 0 && coverProgress < 1) {
            content.style.transform = 'translateY(' + (-24 * coverProgress) + 'px)';
          } else if (coverProgress === 0) {
            content.style.transform = '';
          }
        }
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function boot() {
    document.querySelectorAll('.evora-chapters').forEach(initEvoraChapters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.evora-chapters');
    if (section) initEvoraChapters(section);
  });
})();
